import {
  MortgageExpertContactDetails,
  MortgageExpertContainer,
} from "pages/Application/Recommendation/Recommendation.styles"
import React from "react"

interface MortgageExpertInfo {
  image?: string
  name: string
  phone?: string
  email?: string
}

export const MortgageExpertInfo = ({ image, name, phone, email }: MortgageExpertInfo) => {
  return (
    <MortgageExpertContainer>
      {image && (
        <img src={image} alt="your mortgage expert" aria-label={"your mortgage expert"}></img>
      )}
      <MortgageExpertContactDetails>
        <p>
          This recommendation was created by your Mortgage Expert <b>{name}</b>
        </p>
        <div>
          <div>{phone}</div>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
      </MortgageExpertContactDetails>
    </MortgageExpertContainer>
  )
}
